<div *ngIf="hasInitialMyTasks">
  <iaud-table [data]="myTasksTableData" [options]="myTasksOptions" [forceReloadEvent]="forceReloadEvent"
    [dataRefreshCallback]="reloadMyTasks.bind(this)">
  </iaud-table>
</div>

<ng-template #workflowCell let-rowData="rowData">
  <span *ngIf="rowData.sidId">SID</span>
  <span *ngIf="rowData.auditId">Audit</span>
</ng-template>
<ng-template #requestCell let-rowData="rowData">
  <span *ngIf="rowData.sidId">
    <a [routerLink]="['/', 'sid', rowData.sidId,'capa', rowData.id]">{{rowData.capaId}}</a>
  </span>
  <span *ngIf="rowData.auditId">
      <a [routerLink]="['/', 'audit', rowData.auditId, 'finding', rowData.findingDataId, 'capa', rowData.id]">{{rowData.capaId}}</a>
  </span>
</ng-template>
<ng-template #idFieldCell let-detailData="detailData">
  <label *ngIf="detailData.item['sidId']">SID ID</label>
  <label *ngIf="detailData.item['auditId']">Audit ID</label>
  <p *ngIf="detailData.item['sidId']">{{detailData.item['sidStrId']}}</p>
  <p *ngIf="detailData.item['auditId']">{{detailData.item['auditStrId']}}</p>
</ng-template>
<ng-template #titleFieldCell let-detailData="detailData">
  <label *ngIf="detailData.item['sidId']">SID Title</label>
  <label *ngIf="detailData.item['auditId']">Audit Title</label>
  <p *ngIf="detailData.item['sidId']">{{detailData.item['sidTitle']}}</p>
  <p *ngIf="detailData.item['auditId']">{{detailData.item['auditTitle']}}</p>
</ng-template>